import React from 'react';

export default function MemberDashboardLayoutToolbar({
  showReset,
  onReset,
}) {
  return (
    <div className="member-dashboard__layout-toolbar">
      <div
        className="member-dashboard__layout-hint-card"
        data-resource="private.navbar.personalhub.layout"
        data-action="read"
        data-description="Personal hub — layout customization hint"
      >
        <p className="member-dashboard__layout-hint-text">
          You can rearrange and resize any cards to personalize your dashboard layout.
        </p>
      </div>

      {showReset ? (
        <button
          type="button"
          className="member-dashboard__layout-reset-btn"
          onClick={onReset}
          data-resource="private.navbar.personalhub.layout"
          data-action="execute"
          data-description="Personal hub — reset layout to default"
        >
          Reset layout
        </button>
      ) : null}
    </div>
  );
}
